
import { call, put, select } from 'redux-saga/effects';

import showroom from '../../../libs/showroom'
import { getQuoteId, getConfig, getShowroomQueryParams } from '../../selectors';
import { Creators as actions } from '../../actions';
import { transformFinanceOptionsRequest } from './helpers';

/**
 * @param {Object} options
 * @param {Boolean} updateStore
 */
function* updatePaymentOptions(options, updateStore = true) {
    const quoteId = yield select(getQuoteId);
    const { showroomApiUrl, token } = yield select(getConfig);
    const queryParams = yield select(getShowroomQueryParams);
    const { cashPurchaseOption, ...paymentOptions } = options;

    const body = {
        ...options,
        financeOptions: transformFinanceOptionsRequest(options.financeOptions)
    };

    try {
        const response = yield call(showroom.updatePaymentOptions, showroomApiUrl, token, quoteId, queryParams, body);
        if (updateStore === true) {
            yield put(actions.updatePaymentOptionsSuccess(response));
        }
    } catch (error) {
        console.log('updatePaymentOptions', error)
        yield put(actions.handleError(error));
    }
}

export default updatePaymentOptions;
